import pb from './pocketbase';

let resolvedCollection = null;
const REVIEW_COLLECTION_CANDIDATES = ['reviews', 'review'];

const isNotFoundError = (error) => {
  if (!error) return false;
  if (error.status === 404) return true;
  const message = String(error.message || '').toLowerCase();
  return message.includes('not found') || message.includes("wasn't found");
};

const withReviewsCollection = async (operation) => {
  const candidates = resolvedCollection
    ? [resolvedCollection, ...REVIEW_COLLECTION_CANDIDATES.filter((name) => name !== resolvedCollection)]
    : REVIEW_COLLECTION_CANDIDATES;

  let lastNotFoundError = null;

  for (const collectionName of candidates) {
    try {
      const result = await operation(collectionName);
      resolvedCollection = collectionName;
      return result;
    } catch (error) {
      if (!isNotFoundError(error)) throw error;
      lastNotFoundError = error;
    }
  }

  throw lastNotFoundError || new Error('Reviews collection is not available');
};

const reviewsApi = {
  getList: (...args) => withReviewsCollection((name) => pb.collection(name).getList(...args)),
  getFullList: (...args) => withReviewsCollection((name) => pb.collection(name).getFullList(...args)),
  getFirstListItem: (...args) => withReviewsCollection((name) => pb.collection(name).getFirstListItem(...args)),
  create: (...args) => withReviewsCollection((name) => pb.collection(name).create(...args)),
  update: (...args) => withReviewsCollection((name) => pb.collection(name).update(...args)),
  delete: (...args) => withReviewsCollection((name) => pb.collection(name).delete(...args)),
};

export default reviewsApi;
